module.exports = __webpack_public_path__ + "static/media/size_4_on.65f8c854.svg";